import { $get } from "@/utils/request";

// 获取安卓和IOS的下载二维码
export const getAppQrcode = () => {
  return $get(`/v1/official_website/get_app`).then((res: any) => res?.data || {})
}
